import React from 'react';

// Loading indicators (owner 2026-10-02: show a spinner wherever the boards load data, and keep the
// space reserved so the page doesn't jump when results arrive).

// A spinning ring in the board's colour. Announced to screen readers through `label`.
export function Spinner({ label = 'Loading…', className = 'h-8 w-8' }) {
  return (
    <span role="status" className="inline-flex items-center">
      <svg className={`animate-spin text-primary-dark ${className}`} viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeOpacity="0.2" strokeWidth="3" />
        <path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      </svg>
      <span className="sr-only">{label}</span>
    </span>
  );
}

// A centred spinner with a short message, holding `minHeight` of space while content loads.
export function LoadingBlock({ label = 'Loading jobs…', minHeight = 'min-h-[16rem]' }) {
  return (
    <div className={`col-span-full flex w-full flex-col items-center justify-center gap-3 ${minHeight}`} aria-busy="true">
      <Spinner label={label} className="h-10 w-10" />
      <p className="text-sm font-medium text-gray-500" aria-hidden="true">
        {label}
      </p>
    </div>
  );
}

// Shown over a list that is being replaced (next page, new filter): the old results stay in place,
// dimmed, with a spinner on top, so nothing jumps.
export function LoadingOverlay({ label = 'Loading jobs…' }) {
  return (
    <div className="absolute inset-0 z-20 flex justify-center rounded-2xl bg-white/60" aria-busy="true">
      <div className="sticky top-24 mt-10 flex h-fit items-center gap-3 rounded-full bg-white px-5 py-3 shadow-lg ring-1 ring-gray-200">
        <Spinner label={label} className="h-6 w-6" />
        <span className="text-sm font-semibold text-gray-700" aria-hidden="true">
          {label}
        </span>
      </div>
    </div>
  );
}
